import { z } from "zod";
import { type AuthorWithoutId } from "../../firestore";

export const AuthorServerSchema = z
  .object({
    id: z.string().min(1).optional(),
    slug: z.string().min(1).optional(),
  })
  .refine((data) => data.id ?? data.slug, {
    message: "Either id or slug must be provided",
  });

export type AuthorServerQueryParams = z.infer<typeof AuthorServerSchema>;

export const AuthorsServerSchema = z.object({
  limit: z
    .string()
    .refine(
      (val) => {
        const num = Number(val);
        return Number.isInteger(num) && num >= 1 && num <= 50;
      },
      {
        message: "limit must be a string representing an integer between 1 and 50",
      },
    )
    .optional(),
  page: z
    .string()
    .refine(
      (val) => {
        const num = Number(val);
        return Number.isInteger(num) && num >= 1;
      },
      {
        message: "page must be a string representing a positive integer",
      },
    )
    .optional(),
  startAfterDateTimestamp: z.string().optional(),
  onlyWithContent: z.literal("true").optional(),
});

export type AuthorsServerQueryParams = z.infer<typeof AuthorsServerSchema>;

// Transformed audio course author
export type AuthorServerItemWithImageUrl = Omit<AuthorWithoutId, "created_on" | "updated_on"> & {
  id: string;
  imageUrl: string;
  createdOnMillis: number;
  updatedOnMillis: number;
};

export type AuthorServerResponse = AuthorServerItemWithImageUrl;

export interface AuthorsServerResponse {
  authors: AuthorServerResponse[];
  pagination: {
    hasMore: boolean;
    startAfterDateTimestamp?: string;
    totalCount?: number;
  };
}
